<div class="conf-predictive-vc-model" *ngIf="setPredictiveTabClose && compVisibility">
  <div class="bg-white conf-predictive-vc-header p-2" (click)="getPredictiveTabClose(false)">
    <!-- d-flex align-items-center justify-content-evenly p-2  -->
    <div class="d-flex justify-content-evenly align-items-center">
      <div class="d-flex align-items-center">
        <div class="conf-width-twenty">
          <img class="conf-predictive-img-bulb" src="{{confAWSUrlStr}}/common/bulb.svg" />
        </div>
        <div class="conf-width-seventy conf-predictive-recommender">
          Predictive VC
        </div>
      </div>
      <div class="d-flex align-items-center">
        <div class="conf-mrc">
          <img class="conf-tml-logo" src="{{confAWSUrlStr}}/common/fleetverse_logo_solid_wide.svg" />
        </div>
        <div>
          <img class="conf-down-arrow" src="{{confAWSUrlStr}}/common/nav-right.webp" />
        </div>
      </div>
    </div>
  </div>

  <div class="conf-predictive-vc-body">
    <div  *ngIf="predictiveVCfeatureArr.length > 0">
      <strong class="conf-predictive-user-greet">Hello {{userData.first_name}} {{userData.last_name}},</strong>
      <div class="conf-predictive-customer-massage">Based on your current selection, below are the most retailed vehicles in your region</div>
    </div>
    <div class="conf-predictive-vc-div" *ngIf="predictiveVCfeatureArr.length > 0">
      <div *ngFor="let item of predictiveVCfeatureArr" class="conf-predictive-vc-btn-main">
        <div (click)="navigateToSummary(item.vc)">
          <div class="conf-predictive-vc-most-viewed" *ngIf="item.most_viewed">
            Mostly Viewed
          </div>
          <div class="conf-predictive-vc-btn">
            {{item.prod_desc}} ({{item.vc}})
          </div>
        </div>
      </div>

    </div>
    <div *ngIf="predictiveVCfeatureArr.length === 0" class="conf-predictive-empty-list">Nothing to show</div>
  </div>
</div>
<div *ngIf="!setPredictiveTabClose && compVisibility" class="conf-presdictive-vc-wraper"
  (click)="getPredictiveTabOpen(true)">
  <div class="d-flex align-items-center">
    <img class="img-responsive conf-predictive-floating-bulb-img" src="{{confAWSUrlStr}}/common/bulb.svg" />
    <div class="conf-predictive-floating-btn-text">
      Predictive VC
    </div>
  </div>
</div>